// Native HTML5 form validation (replaces jQuery Validate for form[name=contact] and .new_blog_comment)
export function initFormValidation() {
  const contactForm = document.querySelector('form[name=contact]');
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      if (contactForm.checkValidity()) {
        const submitBtn = contactForm.querySelector('input[type=image]');
        if (submitBtn) {
          submitBtn.disabled = true;
        }
      }
    });
  }

  const blogCommentForm = document.querySelector('.new_blog_comment');
  if (blogCommentForm) {
    blogCommentForm.addEventListener('submit', (e) => {
      if (!blogCommentForm.checkValidity()) {
        e.preventDefault();
      }
    });
  }
}
